import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import i18n from "../../../i18n";



const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;

let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}

function replaceWithBr(s) {

  return s.replace(/\n/g, "<br />")
        .replace(/\*\*\*(.*?)\*\*\*/g, '<b><i>$1</i></b>')
        .replace(/\*\*(.*?)\*\*/g, '<i>$1</i>')
        .replace(/\*(.*?)\*/g, '<b>$1</b>')
        .replace(/\b(https?:\/\/\S+|www\.\S+)\b/g, (match) => {
            // Check if the link starts with "www." and does not include a protocol
            if (match.startsWith('www.')) {
              return `<a href="http://${match}" target="_blank">${match}</a>`;
            } else {
              return `<a href="${match}" target="_blank">${match}</a>`;
            }
        })
}

function parseAbout(nameone,nametwo) {
     let texte;
     if (nameone !== "")
     {
        texte = nameone;
      }
      else if (nametwo !== "")
      {
         texte = nametwo;
      }
      else
      {
         texte = ""
      }
      // Liste des voyelles (y compris "Y")
      const voyelles = ['A', 'E', 'I', 'O', 'U', 'Y'];

      // Convertir le texte en majuscules pour la comparaison insensible à la casse
      const texteMajuscules = texte.toUpperCase();

      // Vérifier si le premier caractère est une voyelle
      if (texte === "")
      {
        return ``;
      }
      else if (voyelles.includes(texteMajuscules.charAt(0))) {
        return ` d'${texte}`;
      } else {
        return ` de ${texte}`;
      }
}


function checkType(obj) {
  if (Array.isArray(obj)) {
    return 'array'
  } else if (typeof obj === 'object' && obj !== null) {
    return 'hash'
  } else {
    return 'null'
  }
}


class PopCredits extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();

    this.state = {
     processing: false,
     showInnerDiv: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv() {
    this.setState({
      showInnerDiv: true
    });
  }


  renderHeaderPublisher = (label) => () => {
    return (
      <div style={{height: '40px', lineHeight: '40px'}}>
         <div className="credits-gradient-text" style={{fontWeight: 'bold', fontSize: titleFontSize17+'px'}}>{i18n.t(label)}</div>
      </div>
    )
  }

  renderCrewTwoCol = ({index, item}) => {
    return (
      <div style={{position: 'relative', width: viewportWidth/2+'px', height: '60px',}}>
          <View style={{width: viewportWidth/2+'px', height: '60px', flexDirection: 'row'}}>

                 <View style={{width: 52, height: 60, justifyContent: 'center'}}>
                    <View style={{width: 50, height: 50, borderRadius: 25, backgroundColor: '#28434d'}}><Image source={{uri: item.picture}} style={{width: 50, height: 50, borderRadius: 25, borderWidth: 1, borderColor: '#ccc'}}/></View>
                 </View>
                 <View style={{marginLeft: 10, width: ((viewportWidth/2)-72)+'px', height: 60, justifyContent: 'center'}}>
                      {item.sigle !== "" && <Text numberOfLines={2} style={{fontSize: titleFontSize17+'px', color: item.screenname !== null && item.screenname !== undefined && item.screenname !== '' ? '#0b49ff':'#111', fontWeight: '800'}}>{item.sigle}</Text>}
                      {item.sigle === "" && <Text numberOfLines={2} style={{fontSize: titleFontSize17+'px', color: item.screenname !== null && item.screenname !== undefined && item.screenname !== '' ? '#0b49ff':'#111', fontWeight: '800'}}>{item.name}</Text>}
                 </View>

          </View>
      </div>
    )
  }


  renderCrewThreeCol = ({index, item}) => {
    return (
      <div style={{position: 'relative', width: viewportWidth/3+'px', height: '60px',}}>
          <View style={{width: viewportWidth/3+'px', height: '60px', flexDirection: 'row'}}>

                 <View style={{width: 52, height: 60, justifyContent: 'center'}}>
                    <View style={{width: 50, height: 50, borderRadius: 25, backgroundColor: '#28434d'}}><Image source={{uri: item.picture}} style={{width: 50, height: 50, borderRadius: 25, borderWidth: 1, borderColor: '#ccc'}}/></View>
                 </View>
                 <View style={{marginLeft: 10, width: ((viewportWidth/3)-72)+'px', height: 60, justifyContent: 'center'}}>
                      {item.sigle !== "" && <Text numberOfLines={2} style={{fontSize: titleFontSize17+'px', color: item.screenname !== null && item.screenname !== undefined && item.screenname !== '' ? '#0b49ff':'#111', fontWeight: '800'}}>{item.sigle}</Text>}
                      {item.sigle === "" && <Text numberOfLines={2} style={{fontSize: titleFontSize17+'px', color: item.screenname !== null && item.screenname !== undefined && item.screenname !== '' ? '#0b49ff':'#111', fontWeight: '800'}}>{item.name}</Text>}
                 </View>

          </View>
      </div>
    )
  }


  render() {
    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               justifyContent: 'center', alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.7)'}}>




           {isMobileOnly &&

                  <div className="scroll-area"
                          style={{
                            width: '100%',
                            maxHeight: "100vh",
                            overflowY: "auto",
                            position: "relative",
                            zIndex: 0,
                          }}
                        >

                    <div style={{width: '100%', minHeight: viewportHeight+'px',}}>

                         <AnimatePresence>

                             {this.state.showInnerDiv && (

                                 <motion.div ref={this.popupRef}
                                        initial={{ scale: 0, opacity: 0 }}
                                        exit={{ scale: 0, opacity: 0 }}
                                        whileInView={{ scale: 1, opacity: 1 }}
                                        transition={{ duration: 0.4, ease: 'easeOut' }}
                                        style={{position: 'relative', width: '100%',
                                              minHeight: viewportHeight*1.1+'px',
                                              margin: 'auto', marginTop: '20px', marginBottom: '40px',
                                              backgroundColor: 'white',
                                              borderRadius: '8px',}}>


                                          <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 30, zIndex: 3}}>
                                             <img src={'/img/cancel_icon_grey.png'} style={{width: '36px', height: '36px'}}/>
                                          </div>



                                         <div style={{padding: '20px'}}>


                                               <div style={{clear: 'both', height: '10px'}}/>


                                                 <div style={{display: 'flex', flexDirection: 'row'}}>
                                                     <div style={{paddingRight: '10px'}}>
                                                       <View style={{height: '60px', justifyContent: 'center'}}>
                                                         <Image source={{uri: '/img/handmade_icon_green.png'}} style={{width: '36px', height: '36px'}}/>
                                                       </View>
                                                     </div>
                                                     <div style={{paddingLeft: '0px', paddingRight: '10px'}}>
                                                       <View style={{height: '60px', justifyContent: 'center'}}>
                                                        {this.props.selectedObject.specialtype === 'storrypage' &&
                                                           <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('StorryPage_credits')}</Text>
                                                         }
                                                         {this.props.selectedObject.specialtype === 'moment' &&
                                                            <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('Moment_credits')}</Text>
                                                          }

                                                       </View>
                                                     </div>

                                                 </div>

                                                 <div style={{color: '#555', fontSize: titleFontSize15+'px', marginLeft: '46px', marginTop: '-10px'}}>
                                                    {this.props.selectedObject.specialtype === 'storrypage' &&
                                                       <div>
                                                           <b style={{color: '#56626e'}}>{i18n.t('The_story_crafters')}</b>: {i18n.t('The_voices_behind')}
                                                       </div>
                                                    }
                                                    {this.props.selectedObject.specialtype === 'moment' &&
                                                      <div>
                                                         <b style={{color: '#56626e'}}>{i18n.t('The_moment_crafters')}</b>: {i18n.t('The_voices_behind_moment')}
                                                       </div>
                                                    }
                                                 </div>

                                                 <div style={{clear: 'both', height: '30px'}}/>


                                                 <div style={{width: '100%', margin: 'auto'}}>


                                                           {this.props.selectedObject.crew === null &&
                                                             <div style={{width: '94%', margin: 'auto', color: '#56626e'}}>

                                                                 <div style={{textAlign: 'left', fontSize: titleFontSize22+'px', marginTop: '100px'}}>
                                                                   {i18n.t('No_credits')}
                                                                 </div>

                                                             </div>
                                                           }



                                                           {this.props.selectedObject.crew !== null &&
                                                             <div>

                                                                   {checkType(this.props.selectedObject.crew.publisher) === 'array' &&
                                                                   <FlatList data={this.props.selectedObject.crew.publisher}
                                                                       numColumns={2}
                                                                       ListHeaderComponent={this.renderHeaderPublisher(`Published_by`)}
                                                                       renderItem={this.renderCrewTwoCol}
                                                                       />
                                                                   }
                                                                   {checkType(this.props.selectedObject.crew.publisher) === 'hash' &&
                                                                   <FlatList data={[this.props.selectedObject.crew.publisher]}
                                                                       numColumns={2}
                                                                       ListHeaderComponent={this.renderHeaderPublisher(`Published_by`)}
                                                                       renderItem={this.renderCrewTwoCol}
                                                                       />
                                                                   }

                                                             </div>
                                                           }


                                                 </div>



                                         </div>

                                  </motion.div>
                              )}

                          </AnimatePresence>

                       </div>

                   </div>
            }


            {!isMobileOnly &&

                   <div className="scroll-area"
                           style={{
                             width: '100%',
                             maxHeight: "100vh",
                             overflowY: "auto",
                             position: "relative",
                             zIndex: 0,
                           }}
                         >

                     <div style={{width: '100%', minHeight: viewportHeight+'px',}}>

                          <AnimatePresence>

                              {this.state.showInnerDiv && (

                                  <motion.div ref={this.popupRef}
                                         initial={{ scale: 0, opacity: 0 }}
                                         exit={{ scale: 0, opacity: 0 }}
                                         whileInView={{ scale: 1, opacity: 1 }}
                                         transition={{ duration: 0.4, ease: 'easeOut' }}
                                         style={{position: 'relative', width: '900px',
                                               minHeight: viewportHeight*1.1+'px',
                                               margin: 'auto', marginTop: '20px', marginBottom: '40px',
                                               backgroundColor: 'white',
                                               borderRadius: '8px',}}>

                                         {!isMobileOnly && !isTablet &&
                                           <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                              <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                           </div>
                                         }
                                         {isTablet &&
                                           <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 20, top: 30, zIndex: 3}}>
                                              <img src={'/img/cancel_icon_grey.png'} style={{width: '36px', height: '36px'}}/>
                                           </div>
                                         }


                                          <div style={{padding: '20px'}}>


                                                  <div style={{display: 'flex', flexDirection: 'row'}}>
                                                      <div style={{paddingRight: '10px'}}>
                                                        <View style={{height: '60px', justifyContent: 'center'}}>
                                                          <Image source={{uri: '/img/handmade_icon_green.png'}} style={{width: '36px', height: '36px'}}/>
                                                        </View>
                                                      </div>
                                                      <div style={{paddingLeft: '0px', paddingRight: '10px'}}>
                                                        <View style={{height: '60px', justifyContent: 'center'}}>
                                                         {this.props.selectedObject.specialtype === 'storrypage' &&
                                                            <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('StorryPage_credits')}</Text>
                                                          }
                                                          {this.props.selectedObject.specialtype === 'moment' &&
                                                             <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('Moment_credits')}</Text>
                                                           }

                                                        </View>
                                                      </div>

                                                  </div>

                                                  <div style={{color: '#555', fontSize: titleFontSize16+'px', marginLeft: '46px', marginTop: '-10px'}}>
                                                     {this.props.selectedObject.specialtype === 'storrypage' &&
                                                        <div>
                                                            <b style={{color: '#56626e'}}>{i18n.t('The_story_crafters')}</b>: {i18n.t('The_voices_behind')}
                                                        </div>
                                                     }
                                                     {this.props.selectedObject.specialtype === 'moment' &&
                                                       <div>
                                                          <b style={{color: '#56626e'}}>{i18n.t('The_moment_crafters')}</b>: {i18n.t('The_voices_behind_moment')}
                                                        </div>
                                                     }
                                                  </div>

                                                  <div style={{clear: 'both', height: '30px'}}/>


                                                  <div style={{width: '840px', margin: 'auto'}}>


                                                            {this.props.selectedObject.crew === null &&
                                                              <div style={{width: '820px', color: '#56626e'}}>

                                                                  <div style={{textAlign: 'left', fontSize: titleFontSize22+'px', marginTop: '100px'}}>
                                                                    {i18n.t('No_credits')}
                                                                  </div>

                                                              </div>
                                                            }



                                                            {this.props.selectedObject.crew !== null &&
                                                              <div>

                                                                    {checkType(this.props.selectedObject.crew.publisher) === 'array' &&
                                                                    <FlatList data={this.props.selectedObject.crew.publisher}
                                                                        style={{width: '840px'}}
                                                                        numColumns={3}
                                                                        ListHeaderComponent={this.renderHeaderPublisher(`Published_by`)}
                                                                        renderItem={this.renderCrewThreeCol}
                                                                        />
                                                                    }
                                                                    {checkType(this.props.selectedObject.crew.publisher) === 'hash' &&
                                                                    <FlatList data={[this.props.selectedObject.crew.publisher]}
                                                                        style={{width: '840px'}}
                                                                        numColumns={3}
                                                                        ListHeaderComponent={this.renderHeaderPublisher(`Published_by`)}
                                                                        renderItem={this.renderCrewThreeCol}
                                                                        />
                                                                    }

                                                              </div>
                                                            }


                                                  </div>



                                          </div>

                                   </motion.div>
                               )}

                           </AnimatePresence>

                        </div>

                    </div>
             }

       </div>
    );
  }
}

export default PopCredits;
